import {createSelector} from '@reduxjs/toolkit'
import { APPLICATION_STATUS_PENDING_PAYMENT } from '../../app/constants'
import {populateAdditionalBranchesData} from './additionalBranchSelector'

export const branchApplicationReviewSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication, 
    state => state.additionalApplications],
    (components, businessLicenceApplicationData, additionalApplications) => {

        const appData = businessLicenceApplicationData.application?.businessLicenceData

        const newBranches = [];

        if(additionalApplications.additionalBranchApplications
            && Array.isArray(additionalApplications.additionalBranchApplications)) { 
                additionalApplications.additionalBranchApplications.forEach(branchApplication => 
            {
                // 1. branch status will be marked do not renew if user did not select it for renewal
                // 2. branch will be marked deleted if user clicked on 'Remove Branch' button in the 
                //    add branch application flow.
                if(!branchApplication.markedDeleted 
                        && !branchApplication.markedDoNotRenew 
                        && branchApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT) 
                {
                    if(branchApplication.businessLicenceData
                        && branchApplication.businessLicenceData.additionalBranches 
                        && Array.isArray(branchApplication.businessLicenceData.additionalBranches)) 
                    { 
                        branchApplication.businessLicenceData.additionalBranches.forEach(branch => {
                            newBranches.push({...branch, ...{id : branchApplication.id}})
                        })
                    }
                }
            })
        }

        return Object.assign({},
            components.branchApplicationReview,
            appData,
            {
                applicationSavingRequestStatus : businessLicenceApplicationData.serverRequestStatus,
                supportingDocumentsRawData : businessLicenceApplicationData.application?.documents ?? [],
                reviewDetails : {
                    newBranches : populateAdditionalBranchesData(newBranches),
                }
            }
        )
    }
)

export const branchApplicationReviewSelect = state => ({
    branchApplicationReview: branchApplicationReviewSelector(state)
})
